import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios";
import ElementUI from 'element-ui';
import ElTree from 'element-ui/lib/tree';
import eIconPicker from 'e-icon-picker';
import './assets/fonts/iconfont.css';


import 'element-ui/lib/theme-chalk/index.css';
import moment from "moment";
// 引入全局css
import "./assets/css/global.css"
import "./assets/css/theme.css"
import "./assets/js/tree.js"

import JSONBIG from 'json-bigint';
import { injectBoundSchool } from './utils/schoolScope'


Vue.use(ElementUI)
Vue.component('el-tree', ElTree);
// axios.defaults.baseURL = 'http://127.0.0.1:8080/';
// 本地开发由 vue.config.js 代理，生产环境由同域 Nginx 反向代理
axios.defaults.baseURL = '/api/';
axios.interceptors.request.use(config=>{
  //设置请求头
  config.headers={
    "token":window.sessionStorage.getItem("token"),
    "Client-Type": "admin", // 标识为管理后台请求，后端拦截器需要此标识
    // "Content-Type": "application/octet-stream",
    // "Access-Control-Allow-Origin": "*",
  }
  return injectBoundSchool(config);
})
//处理后台bigint精度丢失问题
axios.defaults.transformResponse = [
  function (data) {
    const json = JSONBIG({
      storeAsString: true
    })
    return json.parse(data)
  }
]

Vue.prototype.$http=axios

//全局过滤器
Vue.filter('dateFormat', (input, formatString = "YYYY-MM-DD HH:mm:ss") => {
  //es5函数参数设置默认值
  //const lastFormatString = formatString || ''

  // moment(input) 把时间字符串转成时间对象
  // format(formatString) 把时间对象，按照指定格式，格式化成符合条件的字符串
  return moment(input).format(formatString)
});

//引入图标库
Vue.use(eIconPicker, {
  // FontAwesome: true,
  ElementUI: true,
  eIcon: true, //自带的图标，来自阿里妈妈
  eIconSymbol: true, //是否开启彩色图标
  addIconList: [],
  removeIconList: [],
  zIndex: 3100 //选择器弹层的最低层,全局配置
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
